module.exports = __webpack_public_path__ + "static/nantesjug-e5382d3c2543cd613fb55c6ffb64a0cf.png";